import { relations } from 'drizzle-orm'
import { index, integer, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getNullableIdReference,
  getPreciseMonetaryField,
  getTimestampWithTimezone,
} from '../common/utils'
import { invoices } from './invoice'
import { products, productTypeEnum } from './product'
import { users } from './user'
import { visits } from './visit'

export const visitLineItemBillingTypeEnum = pgEnum(
  'visit_line_item_billing_type',
  ['billable', 'not_billable', 'tbd'],
)

export const visitLineItems = pgTable(
  'visit_line_items',
  {
    ...getBaseFields(),
    visitId: getIdReference(() => visits.id),
    productId: getNullableIdReference(() => products.id),
    type: productTypeEnum().notNull().default('material'),
    name: text().notNull(),
    quantity: integer().notNull().default(1),
    unitPriceVat0: getPreciseMonetaryField(),
    billingType: visitLineItemBillingTypeEnum().notNull().default('billable'),
    notes: text(),
    invoiceId: getNullableIdReference(() => invoices.id),
    billedAt: getTimestampWithTimezone(),
    billedByUserId: getNullableIdReference(() => users.id),
    paidAt: getTimestampWithTimezone(),
  },
  (table) => [
    ...getBaseIndexes('visit_line_items', table),
    index('visit_line_items_visit_id').on(table.visitId),
  ],
)

export const visitLineItemsRelations = relations(visitLineItems, ({ one }) => ({
  visit: one(visits, {
    fields: [visitLineItems.visitId],
    references: [visits.id],
  }),
  product: one(products, {
    fields: [visitLineItems.productId],
    references: [products.id],
  }),
  invoice: one(invoices, {
    fields: [visitLineItems.invoiceId],
    references: [invoices.id],
  }),
  billedByUser: one(users, {
    fields: [visitLineItems.billedByUserId],
    references: [users.id],
  }),
}))
